import React from 'react';
import { RatioTransactionTableInterface } from '../utils';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import {
    MeasuredServiceTableRowInterface,
    generateColumns,
    useStyles,
} from './MeasuredService.utils';
import { measuredServiceEntityTransformer } from '../../../utils/transformers';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const MeasuredService: React.VFC<RatioTransactionTableInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    ratio,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat);

    const items: MeasuredServiceTableRowInterface[] = data.map((item) =>
        measuredServiceEntityTransformer(item, ratio),
    );

    return (
        <DataGrid<MeasuredServiceTableRowInterface>
            data={items}
            dataQa={'measured-service-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default MeasuredService;
